export default __webpack_public_path__ + "static/media/hht1_direction_songtime_01.dfe673be.jpg";